import type { ProjectsBatchAssignOptions } from "./projects-batch-assign.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";
import type { QueryInvalidateTarget } from "@/services/query";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

export const useProjectsBatchAssign = (
  projects: number[],
  options?: ProjectsBatchAssignOptions
) => {
  const defaultInvalidate: QueryInvalidateTarget[] = [
    ["projects", "list"],
    ...projects.map((id) => ["projects", "get", id]),
  ];

  const onSuccess = useMutationOnSuccess({ ...options, defaultInvalidate });

  const mutationFn = (users: number[]) => {
    return client.projects.batch.assign({ projects, users });
  };

  return useMutation<ApiEmptyResponse, ApiError, number[]>({
    mutationFn,
    onSuccess,
  });
};
